export default __webpack_public_path__ + "static/media/Chandra.ee795393.jpeg";